import React from 'react'
import PropTypes from 'prop-types'

import GoogleMapReact from 'google-map-react'
import { getColConTiempoPres } from '../../inumet_js_lib/model/escalas/escalasVars'
import ColorContraste from '../../inumet_js_lib/model/colores/colorContraste'
import MetConstants from '../../inumet_js_lib/model/datosVars/metConstants'
import DatosVars from '../../inumet_js_lib/model/datosVars/datosVars'
import { isMobile } from 'react-device-detect'
import { Row } from 'react-bootstrap'
import FichaEstacion from '../estaciones/fichaEstacion'
import DatoVarMapMarker, {
    MARKER_NORMAL,
    MARKER_VECTOR,
} from './datoVarMapMarker'
import './MapaDatosVars.css'

const DEFAULT_MARKER_COLOR = 'white'
const DEFAULT_MARKER_COLOR_CONTRAST = 'black'

const colorContrasteDefecto = new ColorContraste(
    DEFAULT_MARKER_COLOR,
    DEFAULT_MARKER_COLOR_CONTRAST
)

class MapaDatosVars extends React.Component {
    constructor(props) {
        super(props)
        this.state = { geoSelection: [] }
        this.crearMarkers = this.crearMarkers.bind(this)
        this.pointBeforeOpenInfoWindow = { lat: null, lng: null }
        this.handleApiLoaded = this.handleApiLoaded.bind(this)
    }

    onLoad() {}

    handleApiLoaded({ map, maps }) {
        this.map = map
        this.maps = maps

        if (this.state.geoSelection && this.state.geoSelection.selectedPoints) {
            this.state.geoSelection.selectedPoints.forEach((point) => {
                this.addMarker(maps, map, point)
            })
        }
    }

    panTo(lat, lng) {
        if (this.map && this.maps) {
            this.map.panTo({ lat, lng })
        }
    }

    crearMarkers() {
        if (this.props.datosVars) {
            let res = []
            let escala = null
            if (this.props.escalas) {
                escala = this.props.escalas.get(this.props.idVariable)
            }
            let datosVars = this.props.datosVars
            let iVar = datosVars.iVar(this.props.idVariable)
            let iFecha = this.props.iFecha
            let iFechaGral = datosVars.getIFechaGralDeIFecha(iVar, iFecha)
            datosVars.mapXEstaciones(
                iVar,
                iFechaGral,
                (iEstacion, dato) => {
                    let esNuloDato = datosVars.esNulo(dato)
                    if (!esNuloDato || this.props.mostrarNulos) {
                        let mostrarMarker = true
                        let datoParaCalculoColor = dato
                        if (
                            this.props.idVariable ===
                                MetConstants.VAR_ID_PRECIPR3_24H_ACUM &&
                            dato === 'TRAZA'
                        ) {
                            datoParaCalculoColor = 0.1
                        }
                        let colCon =
                            escala && !esNuloDato
                                ? escala.getColCon(datoParaCalculoColor)
                                : colorContrasteDefecto
                        if (
                            this.props.idVariable ===
                            MetConstants.VAR_ID_TIEMPO_PRESENTE_PRIMARIO_1H_INST
                        ) {
                            colCon = getColConTiempoPres(dato)
                        }

                        let tipo = MARKER_NORMAL
                        let rotacion = 0
                        // let datoPrimario = null;
                        let datoSecundario = null
                        let label1 = ''
                        let label2 = ''
                        let vector =
                            MetConstants.varsVectoriales[this.props.idVariable]
                        if (vector && vector.size() >= 2) {
                            let iVar1 = null
                            let iVar2 = null
                            if (vector.tieneDir()) {
                                tipo = MARKER_VECTOR
                                let iVarDir = datosVars.iVar(vector.getValue(0))
                                rotacion = datosVars.getDato(
                                    iVarDir,
                                    iEstacion,
                                    iFecha,
                                    false
                                )
                                iVar1 = datosVars.iVar(vector.getValue(1))
                                if (vector.size() > 2)
                                    iVar2 = datosVars.iVar(vector.getValue(2))
                                // Obtengo la escala del valor en la primera posicion del vector que es el modulo
                                if (this.props.escalas) {
                                    escala = this.props.escalas.get(
                                        vector.getValue(1)
                                    )
                                }
                            } else {
                                iVar1 = datosVars.iVar(vector.getValue(0))
                                iVar2 = datosVars.iVar(vector.getValue(1))
                            }
                            dato = datosVars.getDato(iVar1, iEstacion, iFecha)
                            datoSecundario = datosVars.getDato(
                                iVar2,
                                iEstacion,
                                iFecha
                            )
                            if (escala) {
                                if (
                                    vector.getValue(2) ===
                                        MetConstants.VAR_ID_INTVIENTO_10M_MAX ||
                                    vector.getValue(2) ===
                                        MetConstants.VAR_ID_INTRAFAGA_1H_INST ||
                                    vector.getValue(2) ===
                                        MetConstants.VAR_ID_INTVIENTO_1H_MAX
                                ) {
                                    if (!datosVars.esNulo(datoSecundario)) {
                                        colCon =
                                            escala.getColCon(datoSecundario)
                                    } else {
                                        colCon = escala.getColCon(dato)
                                    }
                                } else {
                                    colCon = escala.getColCon(dato)
                                }
                            }

                            if (datosVars.esNulo(datoSecundario))
                                datoSecundario = null
                            mostrarMarker =
                                !datosVars.esNulo(dato) &&
                                !datosVars.esNulo(rotacion)
                            label1 = vector.getLabel(0)
                            label2 = vector.getLabel(1)
                        }
                        if (mostrarMarker) {
                            let estacion =
                                this.props.datosVars.getEstacionAt(iEstacion)
                            res.push(
                                <DatoVarMapMarker
                                    key={iEstacion + '_' + iVar + '_' + iFecha}
                                    lat={estacion.latitud}
                                    lng={estacion.longitud}
                                    backgroundColor={colCon.color}
                                    textColor={colCon.contraste}
                                    val1={dato}
                                    val2={datoSecundario}
                                    label1={label1}
                                    label2={label2}
                                    estacion={this.props.estaciones.getById(
                                        estacion.id
                                    )}
                                    idsVariablesEnFichaEstacion={
                                        this.props.idsVariablesEnFichaEstacion
                                    }
                                    idsVariablesTooltip={
                                        this.props.idsVariablesTooltip
                                    }
                                    datosVars={this.props.datosVars}
                                    tipo={tipo}
                                    rotacion={rotacion}
                                    graficasVariablesCombinadas={
                                        this.props.graficasVariablesCombinadas
                                    }
                                    idVarGrafica={this.props.idVarGrafica}
                                    onClick={() => {
                                        if (this.map) {
                                            this.setState({
                                                idEstacionSel: estacion.id,
                                            })
                                        }
                                    }}
                                    onCloseInfoWindow={() => {
                                        if (this.map) {
                                            this.setState({
                                                idEstacionSel: null,
                                            })
                                        }
                                    }}
                                    iFecha={this.props.iFecha}
                                    opcionesVars={this.props.opcionesVars}
                                />
                            )
                        }
                    }
                },
                false,
                this.props.estaciones
            )
            return res
        }
        return []
    }

    render() {
        return (
            <React.Fragment>
                <GoogleMapReact
                    bootstrapURLKeys={
                        {
                            // key: 'AIzaSyD0_rAVqKBVyyA-6kB3hMxNgmMyLRFlno8',  // para la web exclusivo
                            // key: 'AIzaSyD0_rAVqKBVyyA-6kB3hMxNgmMyLRFlno8',  // para android exclusivo
                        }
                    }
                    defaultCenter={{
                        lat: this.props.centroMapaInicial.latitud,
                        lng: this.props.centroMapaInicial.longitud,
                    }}
                    defaultZoom={isMobile ? 6 : 7}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={this.handleApiLoaded}
                    options={{ fullscreenControl: false }}
                >
                    {this.crearMarkers()}
                </GoogleMapReact>
                {this.state.idEstacionSel && (
                    <Row
                        style={{
                            zIndex: 999,
                            position: 'absolute',
                            top: '12%',
                            left: isMobile ? '20px' : '40%',
                        }}
                    >
                        <FichaEstacion
                            width="300px"
                            height="400px"
                            estacion={this.props.estaciones.getById(
                                this.state.idEstacionSel
                            )}
                            onClose={() => {
                                if (this.map) {
                                    this.setState({
                                        idEstacionSel: null,
                                    })
                                }
                            }}
                            idsVariables={
                                this.props.idsVariablesEnFichaEstacion
                            }
                            datosVars={this.props.datosVars}
                            graficasVariablesCombinadas={
                                this.props.graficasVariablesCombinadas
                            }
                            idVarGrafica={this.props.idVarGrafica}
                            opcionesVars={this.props.opcionesVars}
                        />
                    </Row>
                )}
            </React.Fragment>
        )
    }
}

MapaDatosVars.propTypes = {
    idVariable: PropTypes.number,
    datosVars: PropTypes.instanceOf(DatosVars),
    centroMapaInicial: PropTypes.object,
    limitesRectangulo: PropTypes.object,
    escalas: PropTypes.object,
    estaciones: PropTypes.object,
    flex: PropTypes.number,
    iFecha: PropTypes.number,
    mostrarNulos: PropTypes.bool,
    idsVariablesEnFichaEstacion: PropTypes.arrayOf(PropTypes.number),
    idsVariablesTooltip: PropTypes.arrayOf(PropTypes.number),
    graficasVariablesCombinadas: PropTypes.object,
    idVarGrafica: PropTypes.number,
    opcionesVars: PropTypes.object,
}

export { MapaDatosVars as default }
